export const DAILY_STATE = {
  IDLE: 0,
  CREATING: 1,
  FETCHING: 2,
  JOINING: 3,
  JOINED: 4,
  LEAVING: 5,
  LEFT: 6,
  ERROR: 7,
  HAIRCHECK: 8,
  WAITING: 9,
}